<template>
  <v-container class="fill-height">
    <v-row v-if="buildingContent">
      <v-col md="10" offset-md="1">
        <v-alert type="success" v-if="success">
          Building successfully created
        </v-alert>
        <v-alert type="error" v-if="error">
          Something went wrong. Please check the developer console!
        </v-alert>
        <v-tabs v-model="languageTab" background-color="transparent">
          <v-tab v-for="language in languages" :key="language.code" :href="'#' + language.code">
            {{ language.name }}
          </v-tab>
        </v-tabs>
        <v-form @submit.prevent="handleSubmit" id="building-create-form" class="building-create-form" ref="createBuildingForm" v-model="isValid">
          <div v-for="language in languages" :key="language.code" v-show="language.code === languageTab">
              <v-row>
                <v-col md="6">
                  <v-text-field name="title" prepend-icon="mdi-pencil" label="Заглавие" v-model="buildingContent[language.code].title" :rules="[rules.required]" required></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field name="anons" prepend-icon="mdi-pencil" v-model="buildingContent[language.code].notice" label="Анонс"></v-text-field>
                </v-col>
              </v-row>
              <vue-editor placeholder="Описание" v-model="buildingContent[language.code].description" />
              <v-row>
                <v-col md="4">
                  <v-select :items="statuses" prepend-icon="mdi-help-circle" item-text="state" item-value="abbr" label="Статус" v-model="status" :rules="[rules.required]" required></v-select>
                </v-col>
                <v-col md="4">
                  <v-file-input
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-file-image"
                    label="Изображение"
                    v-model="image"
                  ></v-file-input>
                </v-col>
                <v-col md="4">
                  <v-text-field name="year" prepend-icon="mdi-calendar-range" label="Година на построяване" v-model="year" :rules="[rules.required]" required></v-text-field>
                </v-col>
              </v-row>
              <v-expansion-panels v-model="seoPanel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>Локация</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col md="4">
                        <v-text-field name="url" prepend-icon="mdi-earth" label="Линк към Google Maps" v-model="mapsLink"></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field name="lat" prepend-icon="mdi-pencil" label="Координати карта (lat):" v-model="mapsLat"></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field name="lng" prepend-icon="mdi-pencil" label="Координати карта (lng):" v-model="mapsLng"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>SEO</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col md="6">
                        <v-text-field name="slug" prepend-icon="mdi-pencil" label="Слъг" v-model="buildingContent[language.code].slug" :rules="[rules.required]" required></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field name="seo_title" prepend-icon="mdi-pencil" label="Заглавие" v-model="buildingContent[language.code].seoTitle"></v-text-field>
                      </v-col>
                      <v-col md="12">
                        <v-text-field name="seo_description" prepend-icon="mdi-pencil" label="Описание" v-model="buildingContent[language.code].seoDescription"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-row>
                <v-col md="3">
                  <v-switch value label="Покажи на начална" color="indigo" v-model="showInHome"></v-switch>
                </v-col>
                <v-col md="3">
                  <v-switch value input-value="true" label="Активен в сайта" color="indigo" v-model="isActive"></v-switch>
                </v-col>
              </v-row>
          </div>
        </v-form>
        <v-btn color="success" type="submit" form="building-create-form">Запиши</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { uploadImage } from '@/repositories/upload.repository'
import { createBuilding } from '@/repositories/building.repository'
export default {
  data () {
    return {
      image: null,
      year: null,
      status: null,
      mapsLink: null,
      mapsLat: null,
      mapsLng: null,
      showInHome: false,
      isActive: true,
      seoPanel: [0, 1],
      isValid: false,
      languageTab: null,
      buildingContent: null,
      statuses: [
        { state: 'Настоящ проект', abbr: 1 },
        { state: 'Завършен проект', abbr: 3 },
        { state: 'Бъдещ проект', abbr: 2 }
      ],
      rules: {
        required: value => !!value || 'Това поле е задължително!'
      },
      success: false,
      error: false
    }
  },
  created () {
    this.$store.dispatch('fetchLanguages')
      .then(() => {
        this.buildingContent = {};
        for (const language of this.languages) {
          this.buildingContent[language.code] = {
            title: null,
            notice: null,
            description: null,
            seoTitle: null,
            seoDescription: null,
            slug: null
          };
        }
      })
  },
  computed: {
    languages () {
      return this.$store.state.language.languages
    }
  },
  methods: {
    handleSubmit () {
      this.success = false
      this.error = false

      this.$refs.createBuildingForm.validate();
      if (!this.isValid) {
        return
      }

      if (!this.image) {
        this.createBuilding()
        this.scrollToTop()
        return
      }

      this.uploadImage()
      this.scrollToTop()
    },
    uploadImage () {
      const formData = new FormData()
      formData.append('file', this.image)

      try {
        uploadImage(formData)
          .then(res => {
            this.createBuilding(res.data.file)
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    createBuilding (image = null) {
      const buildingData = {
        status: this.status,
        year: this.year,
        mapLink: this.mapsLink,
        mapLng: this.mapsLng,
        mapLat: this.mapsLat,
        showInHome: this.showInHome,
        isActive: this.isActive,
        image,
        ...this.buildingContent
      }

      try {
        createBuilding(buildingData)
          .then(response => {
            const { success } = response.data
            this.success = success
            this.error = !this.success

            this.reset()
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    scrollToTop () {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    reset () {
      this.$refs.createBuildingForm.reset()
    }
  }
}
</script>

<style lang="scss">
.v-form.building-create-form {
  width: 100%;
}
.ql-container.ql-snow,
.ql-toolbar.ql-snow {
  border-color: rgba(0,0,0,.42);
}
.ql-container.ql-snow {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.quillWrapper {
  margin-top: 15px;
}
.theme--light.v-tabs-items {
  background: transparent;
}
</style>
